module.exports = __webpack_public_path__ + "static/media/AnnickStefaninResume.ad88e05b.pdf";